<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">مزودين الخدمة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">مزودين الخدمة</li>
            </ol>
          </div>
        </div>
        <div class="col text-end">
          <button v-if="checkAccess('providers_export')" type="button" class="btn btn-success me-2" @click.prevent="exportExcel">
            <i class="fa fa-file-excel me-1"></i> تصدير Excel
          </button>
        </div>
        <div class="row g-3 mt-3">
          <div class="col-sm-6 col-lg-3">
            <div class="card border-success shadow-sm h-100">
              <div class="card-body">
                <div class="text-muted">المزودون النشطون (متصلون)</div>
                <div class="fs-3 fw-bold text-success">{{ onlineCounts.online.toLocaleString() }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3">
            <div class="card border-secondary shadow-sm h-100">
              <div class="card-body">
                <div class="text-muted">المزودون غير النشطين (غير متصلين)</div>
                <div class="fs-3 fw-bold text-secondary">{{ onlineCounts.offline.toLocaleString() }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="number" v-model="searchIdentity" class="form-control" placeholder="رقم الهوية">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchBlock">
                      <option :value="null">حالة الحظر</option>
                      <option :value="true">محظور</option>
                      <option :value="false">غير محظور</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchOnline">
                      <option value="">حالة الاتصال</option>
                      <option value="true">نشط (متصل)</option>
                      <option value="false">غير نشط (غير متصل)</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">مزودين الخدمة</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>الجوال</th>
                            <th>رقم الهوية</th>
                            <th>محظور</th>
                            <th>حالة الاتصال</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="`${row.id}${indx}`">
                            <td>{{ row.id }}</td>
                            <td>{{ row.name }}</td>
                            <td>{{ row.mobile }}</td>
                            <td>{{ row.identity }}</td>
                            <td>{{ (row.isBlocked)? 'محظور' : 'غير محظور' }}</td>
                            <td><span class="badge" :class="row.isOnline ? 'bg-success' : 'bg-secondary'">{{ row.isOnline ? 'متصل' : 'غير متصل' }}</span></td>
                            <td>{{ statusChoices[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/providers/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('providers_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('providers_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'ProvidersList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      statusChoices: {},
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchIdentity: this.$route.query.identity || '',
      searchBlock: this.$route.query.block || null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      countRows: 0,
      searchOnline: ['true', 'false'].includes(this.$route.query.isOnline) ? this.$route.query.isOnline : '',
      onlineCounts: { online: 0, offline: 0 },
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchIdentity && this.searchIdentity != '')
        urlQuery.push(`identity=${this.searchIdentity}`);
      if(this.searchBlock !== null)
        urlQuery.push(`block=${this.searchBlock}`);
      if(this.searchOnline !== '')
        urlQuery.push(`isOnline=${this.searchOnline}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchIdentity !== null && this.searchIdentity !== '' && this.searchIdentity !== false ? { identity: this.searchIdentity } : {}),
        ...(this.searchBlock !== null && this.searchBlock !== '' && this.searchBlock !== false ? { block: this.searchBlock } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
        ...(this.searchOnline !== '' ? { isOnline: this.searchOnline } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/providers/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.statusChoices = data.statusChoices;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.onlineCounts = data.onlineCounts ?? { online: 0, offline: 0 };
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/providers/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchIdentity = '';
      this.searchBlock = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchOnline = '';
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    async exportExcel(){
      let urlQuery = [];

      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchIdentity && this.searchIdentity != '')
        urlQuery.push(`identity=${this.searchIdentity}`);
      if(this.searchBlock !== null)
        urlQuery.push(`block=${this.searchBlock}`);
      if(this.searchOnline !== '')
        urlQuery.push(`isOnline=${this.searchOnline}`);

      const url = `/api/admin/providers/export${urlQuery.length ? '?' + urlQuery.join('&') : ''}`;

      try {
        const response = await this.$http.get(url, { responseType: 'blob' });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'providers.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        toast('فشل تصدير الملف', 'error');
      }
    }
  },
  created(){
    this.getList();
  }
}
</script>